import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { getCustomerUrl } from "../../constants";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { bankTranslater } from "../../util";
import { type } from "ramda";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportUserPrizes = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs, profileState } = Context();
  const [prizes, setPrizes] = useState(false);
  const [originalPrizes, setOriginalPrizes] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);

  const [loading, setLoading] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    const data = await callApi("userPrizes-getAll", {
      limit: 100000,
      startAfter: "",
      roundDate: selectedRoundDate,
    });

    setPrizes(data);

    setOriginalPrizes(data);
    setLoading(false);
  };

  const handleDownload = async () => {
    const csvData = [["refId", "phone", "message"]];

    originalPrizes.forEach((data, index) => {
      if (data.notifyType === "SMS") {
        csvData.push([
          `${data.userId}${index + 1}`,
          data.phone,
          `  ยินดีด้วยคุณถูกรางวัลมูลค่า ${data.totalPrizes} บาท ตรวจสอบที่ ${getCustomerUrl("/orders")}`,
        ]);
      }
    });
    setCsvData(csvData);
    setCsvFileName(
      `รายงานแจ้งเตือนผู้ถูกรางวัลทางSMS_งวด_${selectedRoundDate}.csv`
    );
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24 mx-auto">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานการแจ้งเตือนผู้ถูกรางวัล"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">รายงานการแจ้งเตือนผู้ถูกรางวัล</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">ประเภท</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                onChange={(e) => {
                  setPrizes(
                    prizes.filter((prize) => {
                      return e.target.value === ""
                        ? originalPrizes
                        : prize.notifyType === e.target.value;
                    })
                  );
                }}
              >
                <option value={""}>all</option>
                <option value={"SMS"}>sms</option>
                <option value={"LINE"}>line</option>
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex col-span-2 items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            <MdPersonSearch className="text-white" />
            ค้นหา
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {/* admins */}
      {prizes && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">แจ้งเตือนผู้ถูกรางวัลทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {originalPrizes.length} ราย
            </p>
          </div>
          <div className="flex justify-between bg-white gap-3 items-center p-3 border-b border-gray-300">
            <div>
              <p className="font-semibold ">
                แจ้งเตือนทางโทรศัพท์{" "}
                <span className="text-xs font-semibold text-[#969797]">
                  {
                    originalPrizes.filter((prize) => prize.notifyType === "SMS")
                      .length
                  }{" "}
                  ราย
                </span>
              </p>
            </div>
            <button
              disabled={!prizes.length}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload();
              }}
            >
              {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
              ดาวโหลด
            </button>
          </div>
          <div className="flex justify-between bg-white gap-3 items-center p-3 border-b border-gray-300">
            <div className="">
              <p className="font-semibold ">
                แจ้งเตือนทางไลน์{" "}
                <span className="text-xs font-semibold text-[#969797]">
                  {
                    originalPrizes.filter(
                      (prize) => prize.notifyType === "LINE"
                    ).length
                  }{" "}
                  ราย
                </span>
              </p>
            </div>
            <button
              disabled={loading}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-orange-400 text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={async () => {
                setLoading(true);
                const status = await callApi("prizes-alertPrizeToUser");
                if (status) {
                  toast({
                    className: "bg-[rgb(59,176,101)]",
                    title: `แจ้งเตือนสำเร็จ`,
                  });
                } else {
                  toast({
                    className: "bg-[#c15b78]",
                    title: `แจ้งเตือนไม่สำเร็จ`,
                  });
                }
                setLoading(false);
              }}
            >
              {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
              แจ้งเตือน
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
